import React from 'react';

import { WorkFeedFailWhale } from '../components/WorkFeedFailWhale/WorkFeedFailWhale';
import { EngagementsTabNavigation } from '../components/EngagementsTabNavigation/EngagementsTabNavigation';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type WorkFeedFailWhalePageProps = {
  name?: string;
};

export const WorkFeedFailWhalePage = ({
  name = 'WORK_FEED_FAIL_WHALE_PAGE',
}: WorkFeedFailWhalePageProps) => {
  useDocumentTitle('Work Feed - Unauthorized');
  return (
    <div data-test={name}>
      <EngagementsTabNavigation
        startTab="OPPORTUNITY_FEED_TAB"
        pathToEngagements="../.."
      />
      <WorkFeedFailWhale />
    </div>
  );
};
